import Vue from "vue";
import fleet from './fleet.js'
import requests from './requests.js'
import contacts from './contacts.js'
import chargerReport from './chargerReport.js'

const user = Vue.observable({data: null});

export default {
    fleet,
    requests,
    user,
    contacts,
    chargerReport
}
